export default {
    'errno': 0,
    'errstr': 'OK',
    'data': {
        'activity_info': {
            'jump_url': 'https://opn.baidu.com/map/2022/sjbhbgz?tpltype=1',
            'icon': 'https://mapclient.cdn.bcebos.com/pano/activity/worldcup/%E6%88%91%E7%9A%84%E7%BA%A2%E5%8C%85%20%E5%85%A5%E5%8F%A3.png'
        },
        'calendar_event': [
            {
                'calendarEventId': 'pano-feed-red-packet-remind',
                'title': '百度地图提醒你来领红包啦',
                'description': '来百度地图看卡塔尔全景，找红包啦',
                'startTime': 1670040000,
                'endTime': 1671336000,
                'remindTimeInterval': 300,
                'count': 1
            },
            {
                'calendarEventId': 'pano-feed-red-packet-remind2',
                'title': '领到的红包可以提现啦',
                'description': '来百度地图看卡塔尔全景找红包',
                'startTime': 1671271200,
                'endTime': 1671357600,
                'remindTimeInterval': 300,
                'count': 1
            }
        ]
    }
};